import { createFileRoute } from "@tanstack/react-router";
import { protectedRoute } from "@/lib/protectedRoute";
import { AdminLayout, beforeAdminLoad } from "@/pages/Admin/AdminLayout";

export const Route = createFileRoute("/admin")({
  component: AdminLayout,
  beforeLoad: (options) => {
    if (options.preload) return;
    const redirect = protectedRoute({ location: window.location });
    if (redirect) return redirect;
    beforeAdminLoad(options);
    return undefined;
  },
});
